import { createFileRoute } from '@tanstack/react-router';

import VoiceSalesDashboardPage from '../../views/dashboard-voice-sales';

export const Route = createFileRoute('/dashboard/voice-sales/')({
  component: VoiceSalesDashboardPage,
});
